import { render, staticRenderFns } from "./TemplatesListCard.vue?vue&type=template&id=83e95f12&scoped=true"
import script from "./TemplatesListCard.vue?vue&type=script&lang=js"
export * from "./TemplatesListCard.vue?vue&type=script&lang=js"
import style0 from "./TemplatesListCard.vue?vue&type=style&index=0&id=83e95f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e95f12",
  null
  
)

export default component.exports